import { IGooglePlace } from "shared/model/ICoworkGeoLocation";

import Config from "../Config/Config";
import GooglePlacesLocationMapper, {
  IGoogleMappedLocation
} from "./GooglePlacesLocationMapper";

declare const google: any;

const US_LOCATION = {
  long: 40.73061,
  lat: -73.935242,
  radius: 10000
};

const MAP_ZOOM = 15;

const DEFAULT_COWORK_BUSINESS_TYPE = `['real_estate_agency','establishment','point_of_interest']`;

export default class GooglePlacesClient {
  public static scriptUrl = `https://maps.googleapis.com/maps/api/js?key=${Config.googlePlacesKey()}&libraries=places`;
  public static divId = "maps";

  private _service: any;
  private _mapper: GooglePlacesLocationMapper;
  private cache: { [key: string]: IGooglePlace[] } = {};

  get service() {
    if (!this._service) {
      this._service = this.createService();
    }

    return this._service;
  }

  get locationsMapper() {
    if (!this._mapper) {
      this._mapper = new GooglePlacesLocationMapper();
    }

    return this._mapper;
  }

  public fetchPlaces = async (query: string, generalSearch? : boolean): Promise<IGooglePlace[]> => {
    if (this.cache[query]) {
      return this.cache[query];
    }

    const results = await this.textSearch(query, generalSearch);

    this.cache[query] = results;

    const predictions = results.map(
      (prediction: any): IGooglePlace | null => {
        const { place_id, formatted_address, name } = prediction;
        if (!place_id || !formatted_address || !name) {
          return null;
        }
        return { id: place_id, name, formattedAddress: formatted_address };
      }
    );

    const filtered = predictions.filter((item: any) => item !== null);

    this.cache[query] = filtered;

    return filtered;
  };

  private async textSearch(query: string, generalSearch? : boolean): Promise<any> {
    const request = this.requestPlacesParams(query, this.createLocation(), generalSearch);

    return new Promise<any>((resolve, reject) => {
      this.service.textSearch(request, (results: any, status: string) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(results);
        } else if (
          status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS
        ) {
          resolve([]);
        } else {
          reject(status);
        }
      });
    });
  }
  private requestPlacesParams = (query: string, location: any, generalSearch? : boolean) => {
    const mappedLocation = this.locationsMapper.map(query);
    const type = generalSearch ?  [] : mappedLocation.businessType || DEFAULT_COWORK_BUSINESS_TYPE;

    const input = generalSearch ?
     this.mapTextSearchQuery(mappedLocation) : this.mapTextSearchQueryForCoworkSearch(mappedLocation)
    return {
      type,
      region: ".us",
      input
    };
  };

  private createLocation = () =>
    new google.maps.LatLng(US_LOCATION.long, US_LOCATION.lat);

  private createService() {
    const location = this.createLocation();

    const map = new google.maps.Map(
      document.getElementById(GooglePlacesClient.divId),
      {
        center: location,
        zoom: MAP_ZOOM
      }
    );
    const maps = document.getElementById(GooglePlacesClient.divId);
    if(maps) {
      maps.style.display = "none";
    }
    return new google.maps.places.PlacesService(map);
  }

  private mapTextSearchQueryForCoworkSearch = (
    location: IGoogleMappedLocation
  ) => {
    let searchQuery = location.value;

    if (!location.removeStaticKeywords) {
      searchQuery = searchQuery.concat(" cowork");
    }

    return `${searchQuery} location:"united states"`;
  };
  private mapTextSearchQuery = (
    location: IGoogleMappedLocation
  ) => {
    const searchQuery = location.value;
    return `${searchQuery} location:"united states"`;
  };
}



// WEBPACK FOOTER //
// ./src/services/Google/GooglePlacesClient.ts